module.exports = __webpack_public_path__ + "static/media/pediatric-health-services2.6ebf8cef.jpg";